/* ==========================================================================
   fe-quote-slider — the testimonial card's crossfade slider.

   One slide visible at a time, dots to move between them. Autoplay is opt-in
   and pauses on hover, on focus and while the tab is hidden — a quote that
   changes while someone is halfway through reading it is worse than no
   rotation at all. Reduced-motion visitors never get autoplay, but the dots
   still work, so every quote stays reachable.

   With fewer than two slides the element does nothing: the section prints no
   dots in that case, so a single testimonial is just a static card.
   ========================================================================== */

if (!customElements.get('fe-quote-slider')) {
  customElements.define(
    'fe-quote-slider',
    class FeQuoteSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-quote]'));
        if (this.slides.length < 2) return;

        this.dots = Array.from(this.querySelectorAll('[data-goto]'));
        this.index = 0;
        this.delay = Number(this.dataset.autoplay) || 0;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');

        this.addEventListener('click', this.onClick);
        this.addEventListener('pointerenter', this.pause);
        this.addEventListener('pointerleave', this.play);
        this.addEventListener('focusin', this.pause);
        this.addEventListener('focusout', this.play);
        document.addEventListener('visibilitychange', this.onVisibility);

        this.show(0);
        this.play();
      }

      disconnectedCallback() {
        this.pause();
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('pointerenter', this.pause);
        this.removeEventListener('pointerleave', this.play);
        this.removeEventListener('focusin', this.pause);
        this.removeEventListener('focusout', this.play);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      onClick = (event) => {
        const dot = event.target.closest('[data-goto]');
        if (!dot) return;
        this.show(Number(dot.dataset.goto));
      };

      onVisibility = () => {
        if (document.hidden) this.pause();
        else this.play();
      };

      play = () => {
        this.pause();
        if (!this.delay || this.reduced.matches) return;
        this.timer = setInterval(() => this.show(this.index + 1), this.delay);
      };

      pause = () => {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      };

      show(next) {
        // wraps in both directions, so the dots and the timer share one path
        const total = this.slides.length;
        this.index = ((next % total) + total) % total;

        this.slides.forEach((slide, i) => {
          slide.hidden = i !== this.index;
        });

        this.dots.forEach((dot, i) => {
          const on = i === this.index;
          dot.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }
    }
  );
}
